module.exports = __webpack_public_path__ + "img/card_fotos.9c146f79.jpg";